/** @format */

import type { RootState } from "../store/store";

// ── Active business / tenant context ─────────────────────────────────────
export const selectActiveBusinessId = (state: RootState) =>
    state.collect.activeBusinessId;
export const selectActiveBusiness = (state: RootState) =>
    state.collect.activeBusiness;
export const selectActiveBusinessRole = (state: RootState) =>
    state.collect.activeBusinessRole;
export const selectIsPlatformSuperAdmin = (state: RootState) =>
    state.collect.isPlatformSuperAdmin;
export const selectImpersonation = (state: RootState) =>
    state.collect.impersonation;
export const selectBusinessMemberships = (state: RootState) =>
    state.collect.memberships ?? [];
export const selectIsLoadingBusinesses = (state: RootState) =>
    state.collect.isLoadingBusinesses;
export const selectBusinessesError = (state: RootState) =>
    state.collect.businessesError;
export const selectIsCreatingBusiness = (state: RootState) =>
    state.collect.isCreatingBusiness;
export const selectCreateBusinessError = (state: RootState) =>
    state.collect.createBusinessError;
export const selectIsUpdatingBusiness = (state: RootState) =>
    state.collect.isUpdatingBusiness;
export const selectUpdateBusinessError = (state: RootState) =>
    state.collect.updateBusinessError;

// ── QuickBooks ───────────────────────────────────────────────────────────
export const selectQuickBooks = (state: RootState) => state.collect.quickbooks;
export const selectIsLoadingQuickBooks = (state: RootState) =>
    state.collect.isLoadingQuickBooks;
export const selectQuickBooksError = (state: RootState) =>
    state.collect.quickBooksError;
export const selectIsStartingQbConnect = (state: RootState) =>
    state.collect.isStartingQbConnect;
export const selectStartQbConnectError = (state: RootState) =>
    state.collect.startQbConnectError;
export const selectQbConnectAuthUrl = (state: RootState) =>
    state.collect.qbConnectAuthUrl;
export const selectIsDisconnectingQb = (state: RootState) =>
    state.collect.isDisconnectingQb;
export const selectDisconnectQbError = (state: RootState) =>
    state.collect.disconnectQbError;
export const selectIsQuickBooksConnected = (state: RootState) =>
    state.collect.quickbooks?.status === "active";

// ── Sync ─────────────────────────────────────────────────────────────────
export const selectLatestSyncJob = (state: RootState) =>
    state.collect.latestSyncJob;
export const selectSyncJobs = (state: RootState) => state.collect.syncJobs ?? [];
export const selectIsSyncing = (state: RootState) => state.collect.isSyncing;
export const selectSyncError = (state: RootState) => state.collect.syncError;
export const selectIsLoadingSyncJobs = (state: RootState) =>
    state.collect.isLoadingSyncJobs;
export const selectSyncJobsError = (state: RootState) =>
    state.collect.syncJobsError;

// ── Customers ────────────────────────────────────────────────────────────
export const selectCustomers = (state: RootState) => state.collect.customers ?? [];
export const selectCustomersCursor = (state: RootState) =>
    state.collect.customersCursor;
export const selectCurrentCustomer = (state: RootState) =>
    state.collect.currentCustomer;
export const selectIsLoadingCustomers = (state: RootState) =>
    state.collect.isLoadingCustomers;
export const selectCustomersError = (state: RootState) =>
    state.collect.customersError;

// ── Invoices ─────────────────────────────────────────────────────────────
export const selectInvoices = (state: RootState) => state.collect.invoices ?? [];
export const selectInvoicesCursor = (state: RootState) =>
    state.collect.invoicesCursor;
export const selectCurrentInvoice = (state: RootState) =>
    state.collect.currentInvoice;
export const selectIsLoadingInvoices = (state: RootState) =>
    state.collect.isLoadingInvoices;
export const selectInvoicesError = (state: RootState) =>
    state.collect.invoicesError;

export const selectArAging = (state: RootState) => state.collect.arAging;
export const selectIsLoadingArAging = (state: RootState) =>
    state.collect.isLoadingArAging;
export const selectArAgingError = (state: RootState) =>
    state.collect.arAgingError;

export const selectDashboardOverview = (state: RootState) =>
    state.collect.dashboardOverview;
export const selectIsLoadingDashboardOverview = (state: RootState) =>
    state.collect.isLoadingDashboardOverview;
export const selectDashboardOverviewError = (state: RootState) =>
    state.collect.dashboardOverviewError;

// ── Campaigns ────────────────────────────────────────────────────────────
export const selectCampaigns = (state: RootState) => state.collect.campaigns ?? [];
export const selectCurrentCampaign = (state: RootState) =>
    state.collect.currentCampaign;
export const selectIsLoadingCampaigns = (state: RootState) =>
    state.collect.isLoadingCampaigns;
export const selectCampaignsError = (state: RootState) =>
    state.collect.campaignsError;
export const selectIsSavingCampaign = (state: RootState) =>
    state.collect.isSavingCampaign;
export const selectCampaignSaveError = (state: RootState) =>
    state.collect.campaignSaveError;

// ── Templates ────────────────────────────────────────────────────────────
export const selectTemplates = (state: RootState) => state.collect.templates ?? [];
export const selectCurrentTemplate = (state: RootState) =>
    state.collect.currentTemplate;
export const selectIsLoadingTemplates = (state: RootState) =>
    state.collect.isLoadingTemplates;
export const selectTemplatesError = (state: RootState) =>
    state.collect.templatesError;
export const selectIsSavingTemplate = (state: RootState) =>
    state.collect.isSavingTemplate;
export const selectTemplateSaveError = (state: RootState) =>
    state.collect.templateSaveError;

// ── Dunning activity ─────────────────────────────────────────────────────
export const selectDunningEvents = (state: RootState) =>
    state.collect.dunningEvents ?? [];
export const selectDunningEventsCursor = (state: RootState) =>
    state.collect.dunningEventsCursor;
export const selectIsLoadingDunningEvents = (state: RootState) =>
    state.collect.isLoadingDunningEvents;
export const selectDunningEventsError = (state: RootState) =>
    state.collect.dunningEventsError;
export const selectIsRunningDunning = (state: RootState) =>
    state.collect.isRunningDunning;
export const selectRunDunningError = (state: RootState) =>
    state.collect.runDunningError;
export const selectLastDunningRun = (state: RootState) =>
    state.collect.lastDunningRun;
export const selectIsSendingManualReminder = (state: RootState) =>
    state.collect.isSendingManualReminder;
export const selectManualReminderError = (state: RootState) =>
    state.collect.manualReminderError;
export const selectLastManualReminder = (state: RootState) =>
    state.collect.lastManualReminder;

// ── Invoice timeline ─────────────────────────────────────────────────────
export const selectInvoiceTimeline = (state: RootState) =>
    state.collect.invoiceTimeline;
export const selectIsLoadingTimeline = (state: RootState) =>
    state.collect.isLoadingTimeline;
export const selectTimelineError = (state: RootState) =>
    state.collect.timelineError;

// ── Recovery state machine (Stage 2A) ────────────────────────────────────
export const selectRecoveryStateMetadata = (state: RootState) =>
    state.collect.recoveryStateMetadata ?? [];
export const selectIsLoadingRecoveryStateMetadata = (state: RootState) =>
    state.collect.isLoadingRecoveryStateMetadata;
export const selectRecoveryStateMetadataError = (state: RootState) =>
    state.collect.recoveryStateMetadataError;
export const selectInvoiceTransitions = (state: RootState) =>
    state.collect.invoiceTransitions ?? [];
export const selectIsLoadingInvoiceTransitions = (state: RootState) =>
    state.collect.isLoadingInvoiceTransitions;
export const selectInvoiceTransitionsError = (state: RootState) =>
    state.collect.invoiceTransitionsError;
export const selectIsTransitioningInvoiceState = (state: RootState) =>
    state.collect.isTransitioningInvoiceState;
export const selectTransitionInvoiceStateError = (state: RootState) =>
    state.collect.transitionInvoiceStateError;

// ── Promise-to-Pay (Stage 2B) ──────────────────────────────────────────
export const selectInvoicePromises = (state: RootState) =>
    state.collect.invoicePromises ?? [];
export const selectIsLoadingInvoicePromises = (state: RootState) =>
    state.collect.isLoadingInvoicePromises;
export const selectInvoicePromisesError = (state: RootState) =>
    state.collect.invoicePromisesError;
export const selectBusinessPromises = (state: RootState) =>
    state.collect.businessPromises ?? [];
export const selectBusinessPromisesCursor = (state: RootState) =>
    state.collect.businessPromisesCursor;
export const selectIsLoadingBusinessPromises = (state: RootState) =>
    state.collect.isLoadingBusinessPromises;
export const selectBusinessPromisesError = (state: RootState) =>
    state.collect.businessPromisesError;
export const selectIsSavingPromise = (state: RootState) =>
    state.collect.isSavingPromise;
export const selectPromiseSaveError = (state: RootState) =>
    state.collect.promiseSaveError;

// ── Recovery Queue + Escalation (Stage 2C) ──────────────────────────────
export const selectRecoveryQueue = (state: RootState) =>
    state.collect.recoveryQueue;
export const selectRecoveryQueueCursor = (state: RootState) =>
    state.collect.recoveryQueueCursor;
export const selectIsLoadingRecoveryQueue = (state: RootState) =>
    state.collect.isLoadingRecoveryQueue;
export const selectRecoveryQueueError = (state: RootState) =>
    state.collect.recoveryQueueError;
export const selectRecoveryQueueSummary = (state: RootState) =>
    state.collect.recoveryQueueSummary;
export const selectIsLoadingRecoveryQueueSummary = (state: RootState) =>
    state.collect.isLoadingRecoveryQueueSummary;
export const selectRecoveryQueueSummaryError = (state: RootState) =>
    state.collect.recoveryQueueSummaryError;
export const selectIsAssigningInvoice = (state: RootState) =>
    state.collect.isAssigningInvoice;
export const selectAssignInvoiceError = (state: RootState) =>
    state.collect.assignInvoiceError;
export const selectIsManualEscalating = (state: RootState) =>
    state.collect.isManualEscalating;
export const selectManualEscalateError = (state: RootState) =>
    state.collect.manualEscalateError;
export const selectLastEscalationDecision = (state: RootState) =>
    state.collect.lastEscalationDecision;

// ── Customer Replies (Stage 2D) ─────────────────────────────────────────
export const selectReplies = (state: RootState) => state.collect.replies;
export const selectRepliesCursor = (state: RootState) =>
    state.collect.repliesCursor;
export const selectIsLoadingReplies = (state: RootState) =>
    state.collect.isLoadingReplies;
export const selectRepliesError = (state: RootState) =>
    state.collect.repliesError;
export const selectCurrentReply = (state: RootState) =>
    state.collect.currentReply;
export const selectIsLoadingCurrentReply = (state: RootState) =>
    state.collect.isLoadingCurrentReply;
export const selectCurrentReplyError = (state: RootState) =>
    state.collect.currentReplyError;
export const selectRepliesSummary = (state: RootState) =>
    state.collect.repliesSummary;
export const selectIsLoadingRepliesSummary = (state: RootState) =>
    state.collect.isLoadingRepliesSummary;
export const selectRepliesSummaryError = (state: RootState) =>
    state.collect.repliesSummaryError;
export const selectIsProcessingReply = (state: RootState) =>
    state.collect.isProcessingReply;
export const selectReplyActionError = (state: RootState) =>
    state.collect.replyActionError;

// ── Collections metrics (money collected / outstanding / expected) ──────
export const selectCollectionsMetrics = (state: RootState) =>
    state.collect.collectionsMetrics;
export const selectIsLoadingCollectionsMetrics = (state: RootState) =>
    state.collect.isLoadingCollectionsMetrics;
export const selectCollectionsMetricsError = (state: RootState) =>
    state.collect.collectionsMetricsError;

// ── Recovery analytics (funnel + health score) ─────────────────────────
export const selectRecoveryFunnel = (state: RootState) =>
    state.collect.recoveryFunnel;
export const selectIsLoadingRecoveryFunnel = (state: RootState) =>
    state.collect.isLoadingRecoveryFunnel;
export const selectRecoveryHealth = (state: RootState) =>
    state.collect.recoveryHealth;
export const selectIsLoadingRecoveryHealth = (state: RootState) =>
    state.collect.isLoadingRecoveryHealth;
export const selectRecoveryTrends = (state: RootState) =>
    state.collect.recoveryTrends;
export const selectIsLoadingRecoveryTrends = (state: RootState) =>
    state.collect.isLoadingRecoveryTrends;
